var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1448_41032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.46285 10.2948L5.2673 13.4902C4.96908 13.7885 3.97482 14.4555 3.00937 13.4902C2.04416 12.525 2.71115 11.5306 3.00937 11.2324L6.20492 8.03683C6.20492 8.03683 7.32247 6.89645 8.46285 8.03683C9.60323 9.17721 8.46285 10.2948 8.46285 10.2948ZM10.2638 6.23593C8.6523 4.62448 6.01547 4.62448 4.40402 6.23593L1.20859 9.43148C-0.402862 11.0429 -0.402862 13.6798 1.20859 15.2912C2.81991 16.9025 5.45675 16.9025 7.0682 15.2912L10.2638 12.0957C11.8752 10.4842 11.8752 7.84738 10.2638 6.23593Z",
    fill: "#8DDCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9903 5.7673L9.79476 8.96285C9.49642 9.26119 8.50216 9.92818 7.53683 8.96285C6.5715 7.99752 7.23849 7.00326 7.53683 6.70492L10.7324 3.50949C10.7324 3.50949 11.8499 2.36911 12.9903 3.50949C14.1306 4.64987 12.9903 5.7673 12.9903 5.7673ZM14.7912 1.70859C13.1798 0.0971379 10.5428 0.0971379 8.93148 1.70859L5.73593 4.90402C4.12448 6.51547 4.12448 9.1523 5.73593 10.7638C7.34738 12.3752 9.98422 12.3752 11.5957 10.7638L14.7912 7.5682C16.4025 5.95687 16.4025 3.31991 14.7912 1.70859Z",
    fill: "#7DC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.65758 12.2936C4.65725 12.2933 4.65709 12.2931 4.6566 12.293C4.65448 12.2962 4.65497 12.2962 4.65758 12.2936Z",
    fill: "#7DC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.00937 11.2324L6.20492 8.03683C6.20492 8.03683 7.32247 6.89645 8.46285 8.03683L10.2638 6.23593C8.6523 4.62448 6.01547 4.62448 4.40402 6.23593L1.20859 9.43148C-0.402862 11.0429 -0.402862 13.6798 1.20859 15.2912L3.00937 13.4902C2.04416 12.525 2.71115 11.5306 3.00937 11.2324Z",
    fill: "#8DDCE8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1448_41032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.e6d564ec5bfcc611dd9d80e897a91f22.svg";
export { ForwardRef as ReactComponent };